import CheckIcon from '@mui/icons-material/Check'
import { Table as MuiTable, TableBody, TableCell, TableHead, TableRow, styled } from '@mui/material'
import { AUTHORITIES as AUTH, AUTHORITIES_JP, ORDERED_AUTHORITIES } from 'config'
import { ValueOf } from 'types'

interface Can {
  readonly label: string
  readonly roles: ValueOf<typeof ORDERED_AUTHORITIES>[]
}

const OP_CANS: Can[] = [
  {
    label: '文書の登録.削除',
    roles: [AUTH.REGISTER, AUTH.OPERATOR, AUTH.MANAGER, AUTH.ADMIN],
  },
  {
    label: 'OCR結果の編集',
    roles: [AUTH.REGISTER, AUTH.OPERATOR, AUTH.MANAGER, AUTH.ADMIN],
  },
  {
    label: 'ダブルチェック時の最終確認',
    roles: [AUTH.MANAGER, AUTH.ADMIN],
  },
  {
    label: '結果データの出力',
    roles: [AUTH.REGISTER, AUTH.MANAGER, AUTH.ADMIN],
  },
]

const SETTING_CANS: Can[] = [
  {
    label: 'Template OCR連携設定',
    roles: [AUTH.ADMIN],
  },
  {
    label: 'ユーザー．グループの管理',
    roles: [AUTH.ADMIN],
  },
  {
    label: '運用ルール設定',
    roles: [AUTH.REGISTER, AUTH.MANAGER, AUTH.OPERATOR, AUTH.ADMIN],
  },
]

export default function RoleDescription() {
  return (
    <Table size="small" aria-label="role description table">
      <TableHead>
        <TableRow>
          <TableCell align="center" rowSpan={2} colSpan={2}>
            権限の種類
          </TableCell>
          <TableCell align="center" rowSpan={2}>
            {AUTHORITIES_JP[AUTH.REGISTER]}
          </TableCell>
          <TableCell align="center" colSpan={2}>
            ベリファイ運用フロー
          </TableCell>
          <TableCell align="center" rowSpan={2}>
            {AUTHORITIES_JP[AUTH.ADMIN]}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell align="center">{AUTHORITIES_JP[AUTH.OPERATOR]}</TableCell>
          <TableCell align="center">{AUTHORITIES_JP[AUTH.MANAGER]}</TableCell>
        </TableRow>
      </TableHead>

      <TableBody>
        {OP_CANS.map((can) => (
          <TableRow key={can.label}>
            <TableCell component="th" scope="row" colSpan={2}>
              {can.label}
            </TableCell>
            {ORDERED_AUTHORITIES.map((role) => (
              <CheckCell key={role} checked={can.roles.includes(role)} />
            ))}
          </TableRow>
        ))}

        {SETTING_CANS.map((can, i) => (
          <TableRow key={can.label}>
            {i === 0 && (
              <TableCell component="th" scope="row" rowSpan={SETTING_CANS.length}>
                設定
              </TableCell>
            )}
            <TableCell component="th" scope="row">
              {can.label}
            </TableCell>
            {ORDERED_AUTHORITIES.map((role) => (
              <CheckCell key={role} checked={can.roles.includes(role)} />
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
}

interface CheckCellProps {
  checked: boolean
}
const CheckCell = ({ checked }: CheckCellProps) => (
  <TableCell align="center">{checked && <GreenCheckIcon />}</TableCell>
)

const GreenCheckIcon = styled(CheckIcon)(({ theme }) => ({
  color: theme.palette.primary.main,
}))

const Table = styled(MuiTable)(({ theme }) => ({
  '& .MuiTableCell-root': {
    border: 'solid 1px',
    borderColor: theme.palette.grey[300],
  },
  '& .MuiTableHead-root .MuiTableCell-root': {
    backgroundColor: theme.palette.grey[200],
  },
  '& .MuiTableBody-root .MuiTableRow-root:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
}))
